<template>
<PageShell>
  <h1 class="site-h1">Privacy Policy</h1>
  <p class="site-lead">This Privacy Policy explains how GBAppWhats.com collects, uses, and protects information when you visit our website.</p>
  <p>By using this website, you agree to the practices described in this policy.</p>

  <h2 class="site-h2">Information We Collect</h2>
  <p>Most visitors can browse GBAppWhats without providing personal information.</p>
  <p>However, we may collect limited information such as:</p>
  <ul class="site-ul">
    <li>Browser type</li>
    <li>Device information</li>
    <li>IP address</li>
    <li>Pages visited</li>
    <li>Time spent on the website</li>
    <li>Anonymous analytics data</li>
  </ul>
  <p>If you contact us by email, we may also receive the information you voluntarily provide.</p>

  <h2 class="site-h2">How We Use Information</h2>
  <p>We use collected information to:</p>
  <ul class="site-ul">
    <li>Improve website performance</li>
    <li>Understand visitor interests</li>
    <li>Maintain website security</li>
    <li>Respond to inquiries</li>
    <li>Update and improve our content</li>
  </ul>
  <p>We do not sell personal information to third parties.</p>

  <h2 class="site-h2">Cookies</h2>
  <p>GBAppWhats may use cookies to improve your browsing experience. Cookies help remember user preferences, measure website performance, and support analytics services.</p>
  <p>You can disable cookies through your browser settings if you prefer.</p>

  <h2 class="site-h2">Third-Party Services</h2>
  <p>Our website may use trusted third-party services, including analytics and advertising providers. These services may collect anonymous usage information according to their own privacy policies.</p>
  <p>We may also include links to third-party websites. We are not responsible for the privacy practices or content of external websites.</p>

  <h2 class="site-h2">Data Security</h2>
  <p>We take reasonable measures to protect the information collected through our website. However, no method of online transmission or storage is completely secure.</p>

  <h2 class="site-h2">Children's Privacy</h2>
  <p>GBAppWhats is not intended for children under the age of 13, and we do not knowingly collect personal information from children.</p>

  <h2 class="site-h2">Changes to This Policy</h2>
  <p>We may update this Privacy Policy from time to time. Any changes will be published on this page with the revised effective date.</p>

  <h2 class="site-h2">Contact</h2>
  <p>If you have any questions regarding this Privacy Policy, please contact us at:</p>
  <p><strong>contact@gbappwhats.com</strong></p>
</PageShell>
</template>

<script>
import PageShell from '@/components/PageShell.vue'

export default {
  name: 'Privacy',
  components: { PageShell },
}
</script>
